/*
 * Authors: mariushirjanu
 * Created: 24/11/2023
 */
import { ILogPayload, LogLevel } from '../remote-logger-data.service';

export abstract class TransporterBaseService {
  abstract write(payload:ILogPayload, level?:LogLevel):void;
}